/**
 * Tiny zero-dependency className joiner for conditional/dynamic classes.
 * Falsy parts (false/null/undefined/'') are dropped, the rest joined by spaces.
 *
 *   cx('base', isActive && 'active', isHidden ? 'sr-only' : undefined)
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
